import React from 'react';
import { PatientDevicePortalLogo } from '../../shared/PatientDevicePortalLogo';
import { Checkbox } from '@mui/material';
export const SelectPrimaryPatientMergedRow = ({ patient, patientSelected, primaryPatientId, patientName }) => {
    // Cell classes
    // Last 2 cells have reduced padding
    const tCellClassBase = 'table-cell pt-4 pb-4 align-middle text-center';
    const tCellClass = `${tCellClassBase}`;
    const tCellClassCheckbox = 'table-cell pt-4 pb-4 align-middle';
    // const tCellClassLessPadding = `${tCellClassBase} pr-4`;
    // const tCellTextClass = 'text-sm text-[#333333]';
    return (React.createElement("div", { className: "table-row border-b-2 first-of-type:border-b-0 last-of-type:border-b-0 border-app-gray-line" },
        React.createElement("div", { className: tCellClassCheckbox, style: { display: 'inline-flex' } },
            React.createElement(Checkbox, { onClick: () => patientSelected(patient.secondaryPatientId.toString()), style: { marginRight: '10px' }, size: "medium", color: "primary", checked: primaryPatientId === patient.secondaryPatientId.toString() }),
            React.createElement("div", null, patientName)),
        React.createElement("div", { className: tCellClass },
            React.createElement("div", { className: 'inline-block' },
                React.createElement(PatientDevicePortalLogo, { devicePortalId: patient.secondaryPortalId.toString() })))));
};
